import { WordPress } from "../../../../wordpress/wordpress_api";
import { PublicSite_CustomPageData } from "../../../application.mod";
import { IOWidget, Action, mk_widget } from "widgets-for-react";
import { PublicSiteState } from "../../../../public_site.main.mod";
import { CMSState } from "../../../../cms/blocks/types.gen";
import React from "react";
import { toRelativeUrl } from "../../../../../helpers";
import { link, linkWrapper } from "../../../../cms/blocks/utils.gen";
import { ButtonData } from "../../../../wordpress/types_and_parser/extra_types.mod";
import { getImageAttribute } from "../../../utils/extra_images.mod";

export type ImageTextAttributes = {
    blockName: 'vidda/image-text'
    image_position: 'left' | 'right'
    image: WordPress.MediaResponse
    title: string
    intro: string
    primary_button?: ButtonData
    secondary_button?: ButtonData
}

export interface ImageTextInterface {
    blockName: 'vidda/image-text'
    attrs: ImageTextAttributes
}

export type ImageTextBlockProps<extra_images> = ImageTextAttributes

export type ImageTextBlockStyle = Partial<{
    block_classname: string
    inner_classname: string
    header_classname: string
    title_classname: string
    content_classname: string
    intro_classname: string
    visual_classname: string
}>

export function ImageTextBlock<customBlockData, extra_images>(
    props: ImageTextBlockProps<extra_images>,
    options?: { style: ImageTextBlockStyle; key?: string }
  ): (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => IOWidget<PublicSiteState, Action<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>>> {
    return (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => (public_state: PublicSiteState) => {
      return mk_widget({
        run: _ => ( 
                <section className={`block block--image-text${props.image_position == 'right' ? " block--image-right" : " block--image-left"}`}>
                  <div className="block__inner container--2xl grid--spacing">
                    <div className="block__content">
                    {props.title && <h2 className="block__title typo--3xl">{props.title}</h2>}
                    {props.intro && <p className="block__intro" dangerouslySetInnerHTML={{ __html: props.intro }}></p>}
                    {(props.primary_button || props.secondary_button) && (
                      <footer className="block__footer">
                        {props.primary_button && (
                          link(linkWrapper({title:props.primary_button.text,url:props.primary_button.url}),
                          { classname: 'button button--primary' },
                          props.primary_button.text
                          ) 
                        )}
                        {props.secondary_button && (
                          link(linkWrapper({title:props.secondary_button.text, url:props.secondary_button.url}),
                            { classname: 'button button--secondary' },
                            props.secondary_button.text
                            )
                        )}
                      </footer>
                    )}
                    </div>
                    {props.image && props.image.media_details && 
                      <div className="block__visual">
                        <img
                          src={getImageAttribute(props.image, 'featured', 'source_url')}
                          width={getImageAttribute(props.image, 'featured', 'width')}
                          height={getImageAttribute(props.image, 'featured', 'height')}
                          alt={props.image.alt_text ? props.image.alt_text : ''}
                        />
                      </div>
                    }
                  </div>
                </section>
      )
    })
}}